(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }


      const triggerHeight = window.innerHeight * 0.1; // 10% tinggi layar
      if (scrollTop <= 0) {
        this.header.classList.add('transparent');
      } else if (scrollTop > triggerHeight) {
        this.header.classList.remove('transparent');
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

// logic toggle detail shop
document.querySelectorAll('.mega-menu').forEach(menu => {
  menu.addEventListener('toggle', function () {
    const header = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.header-wrapper');
    

    if (this.open) {

      document.body.style.overflow = 'hidden';

      headerWrapper.classList.add('bg-pink');


      if (header.classList.contains('transparent')) {
        header.classList.remove('transparent');
        header.dataset.wasTransparent = 'true';
      }
    } else {
      // Unlock body scroll
      document.body.style.overflow = '';

    
      headerWrapper.classList.remove('bg-pink');

      // Restore transparent
      if (header.dataset.wasTransparent === 'true') {
        header.classList.add('transparent');
        delete header.dataset.wasTransparent;
      }
    }
  });
});

// logic toggle detail shop
document.querySelectorAll('.menu-drawer-container').forEach(menu => {
  menu.addEventListener('toggle', function () {
    const header = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (this.open) {
      // Lock body scroll
      document.body.style.overflow = 'hidden';

      // Tambahkan bg-pink ke header-wrapper
      headerWrapper.classList.add('bg-pink');

      // Kalau header ada transparent → hapus
      if (header.classList.contains('transparent')) {
        header.classList.remove('transparent');
        header.dataset.wasTransparent = 'true';
      }
    } else {
      // Unlock body scroll
      document.body.style.overflow = '';

      // Hapus bg-pink dari header-wrapper
      headerWrapper.classList.remove('bg-pink');

      // Restore transparent jika sebelumnya ada
      if (header.dataset.wasTransparent === 'true') {
        header.classList.add('transparent');
        delete header.dataset.wasTransparent;
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  if (
    window.location.pathname.includes('/products/') || 
    window.location.pathname.includes('/pages/') || 
    window.location.pathname.includes('/cart') || 
    window.location.pathname.includes('/404') || 
    window.location.pathname.includes('/search')
    
  ) {
    const header = document.querySelector('.shopify-section.section-header');
    if (header) {
      header.classList.remove('transparent');
      
      const observer = new MutationObserver(() => {
        if (header.classList.contains('transparent')) {
          header.classList.remove('transparent');
        }
      });

      observer.observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }
});



  } catch(e) { console.error(e); }
})();
})();
